import { useEffect } from "react";

// 보호 페이지에서 세션이 만료됐을 때 페이지 위에 뜨는 재로그인 안내 모달.
// 강제 이동 없이 안내만 하고, [로그인] 버튼을 누르면 로그인 페이지로 이동한다.
// 세션이 이미 끊긴 상태라 닫기(dismiss)는 제공하지 않는다.
export default function SessionExpiredModal({ onLogin }) {
    // 배경 스크롤 잠금.
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, []);

    return (
        <div style={overlayStyle} role="presentation">
            <div
                style={panelStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="session-expired-title"
            >
                <h2 id="session-expired-title" style={titleStyle}>
                    Your session has expired
                </h2>
                <p style={bodyStyle}>
                    For your security, you’ve been signed out. Please log in again to
                    continue.
                </p>
                <button type="button" style={buttonStyle} onClick={onLogin} autoFocus>
                    Log in
                </button>
            </div>
        </div>
    );
}

const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(6, 8, 11, 0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "1rem",
};

const panelStyle = {
    background: "#ffffff",
    borderRadius: "14px",
    maxWidth: "380px",
    width: "100%",
    padding: "2rem 1.75rem",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.25)",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
};

const titleStyle = {
    margin: 0,
    fontSize: "1.375rem",
    color: "#06080b",
};

const bodyStyle = {
    margin: "0.75rem 0 1.5rem",
    fontSize: "0.95rem",
    lineHeight: 1.5,
    color: "#495460",
};

const buttonStyle = {
    display: "inline-block",
    width: "100%",
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    fontWeight: 600,
    color: "#ffffff",
    background: "#8a6d3b",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
};
